import React, { useEffect, useCallback } from 'react';

const ViewImageModal = ({ image, onClose, onChange }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  return (
    <div className="view-image-backdrop" onClick={handleBackdropClick}>
      <div className="view-image-modal">
        <button className="view-image-close" onClick={onClose}>
          <i className="fa-solid fa-xmark"></i>
        </button>
        
        <div className="view-image-content">
          <img src={image} alt="Photo de profil" />
        </div>
        
        <div className="view-image-actions">
          <button className="btn-view-change" onClick={onChange}>
            <i className="fa-solid fa-camera"></i>
            Changer
          </button>
          <button className="btn-view-close" onClick={onClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewImageModal;
